/** Shared deterministic fallback avatar palette — used wherever a competitor has no
 *  logo so the same brand always gets the same color across every surface. */
const AVATAR_COLORS = [
  "#6c4bff",
  "#f59e0b",
  "#00997d",
  "#3b82f6",
  "#f43f5e",
  "#f97316",
  "#6366f1",
  "#22c55e",
] as const;

/** Deterministic hash-based color for a competitor's fallback initial avatar. */
export function avatarColor(name: string): string {
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = (hash * 31 + name.charCodeAt(i)) >>> 0;
  }
  return AVATAR_COLORS[hash % AVATAR_COLORS.length]!;
}
